<template lang="pug">
  .layout
    y-dialog(v-model='showModal', max-width='500' persistent)
      v-card
        v-card-title.h6.danger500--text.py-6 Missing contact information
        v-card-text
          v-form(ref="form")
            .p1 {{ editIncompleteInvoices.length }} out of {{ invoices.length }} invoices was incompleted. 
            .p1 Enter a valid email address, phone number and correct name for the customer specified below:
            .email.mt-4(v-for="(invoice, index) in editIncompleteInvoices" :key="invoice.id")
              .mb-1.label.basic600--text.text-uppercase {{`#${invoice.rid}`}} {{ invoice.name }} {{invoice.name == "Guest" ? "(Please update guest name)" : ""}}
              v-text-field.mt-2(v-if="originalInvoices[index].name == 'Guest'" v-model='invoice.name' :placeholder="$t('name.placeholder')" background-color="basic200" height="40" outlined dense persistent-hint :rules="rules.not_empty")
              v-text-field.mt-2(v-if="channels.includes('sms')" v-model='invoice.phone' :placeholder="$t('phone.placeholder')" background-color="basic200" height="40" outlined dense persistent-hint :rules="rules.phone" type="tel")
              v-text-field.mt-2(v-if="channels.includes('email')" v-model='invoice.email' :placeholder="$t('email.placeholder')" background-color="basic200" height="40" outlined dense persistent-hint :rules="rules.valid_email" type="email")
              y-checkbox.ma-0.pa-0(v-model='invoice.checked' hide-details)
                template(v-slot:label)
                  .p1.textColorDefault--text Save for future use

        v-card-actions
          v-spacer
          v-btn(color='white', text @click='showModal = !showModal')
            .button-Aa-medium.primary400--text Cancel
          v-btn.mr-2(color='info500' depressed @click="saveContactInFo" :loading="isLoading")
            .button-AA-medium.basic100--text Send

</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'IncompleteInfo',
  props: ['open', 'initialInvoices', 'invoices', 'channels'],
  data: () => ({
    isLoading: false,
    originalInvoices: [],
    editIncompleteInvoices: [],
    rules: {
      not_empty: [val => (val || '').length > 0 || 'This field is required'],
      phone: [
        v => !!v || 'Phone Number is required',
        v => /^(\+?6?01)[0-46-9]-*[0-9]{7,8}$/.test(v) || 'Phone Number must be valid',
      ],
      valid_email: [v => !!v || 'Email is required', v => /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || 'Invalid email address']
    }
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany'
    }),
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  mounted () {
    this.originalInvoices = this.initialInvoices.map(a => ({...a}))
    this.editIncompleteInvoices = [...this.initialInvoices]
  },
  methods: {
    async saveContactInFo () {
      if (!this.$refs.form.validate()) {
        return
      }
      this.isLoading = true
      let hasError = false
      let initialInvoices = [ ...this.editIncompleteInvoices ]
      await this.asyncForEach(this.editIncompleteInvoices, async (income) => {
        try {
          await this.$axios.patch(`/books/${this.company.slug}/incomes/${income.pid}`, { email: income.email, name: income.name, phone: income.phone})
          initialInvoices = initialInvoices.filter((x) => x.pid !== income.pid)
          if (income.checked) {
            let customer = { source: 'manual', email: income.email, name: income.name, phone: income.phone}
            this.axios.post(`/books/${this.company.slug}/customers`, customer).catch(() => {})
          }
        } catch (error) {
          hasError = true
        }
      })
      this.isLoading = false
      if (hasError) {
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        this.editIncompleteInvoices = [ ...initialInvoices ]
        this.$emit('update:initialInvoices', this.editIncompleteInvoices)
        return
      }
      this.showModal = false
      this.$emit('updated')
    }
  }
}
</script>

<style scoped>
</style>

<i18n>
{
  "en": {
    "email": {
      "label": "Email",
      "placeholder": "Email address"
    },
    "phone": {
      "label": "Phone",
      "placeholder": "Phone number"
    },
    "name": {
      "label": "Name",
      "placeholder": "Name"
    },
    "cancel": "Cancel",
    "send": "Send"
  }
}
</i18n>
